export const roundedNumbers = (number) => {
  return Math.round(number * 100) / 100;
};
